import React from 'react';
import { LegacyTempBadgePreview } from './LegacyTempBadgePreview';
import { VerticalTempBadgePreview } from './VerticalTempBadgePreview';

export type StaticTempBadgePreviewProps = {
  templateName: string | undefined;
  badgeName: string;
  jobsiteName: string;
  className?: string;
};

export function StaticTempBadgePreview(
  props: StaticTempBadgePreviewProps,
): React.ReactElement | null {
  const { templateName, badgeName, jobsiteName, className } = props;

  switch (templateName) {
    case 'escort_badge_vertical':
      return (
        <VerticalTempBadgePreview
          jobsiteName={jobsiteName}
          badgeName={badgeName}
          scheme="red"
          badgeType="escorted"
          className={className}
        />
      );
    case 'temporary_badge_vertical':
      return (
        <VerticalTempBadgePreview
          jobsiteName={jobsiteName}
          badgeName={badgeName}
          scheme="purple"
          badgeType="temporary"
          className={className}
        />
      );
    case 'visitor_badge_vertical':
      return (
        <VerticalTempBadgePreview
          jobsiteName={jobsiteName}
          badgeName={badgeName}
          scheme="purple"
          badgeType="visitor"
          className={className}
        />
      );
    case 'temporary_badge_landscape':
      return (
        <LegacyTempBadgePreview
          jobsiteName={jobsiteName}
          badgeName={badgeName}
          className={className}
        />
      );
    default:
      return null;
  }
}
